export default {
  "cat.shoes": "Chaussures",
  "cat.hoodies": "Sweats/Pulls",
  "cat.tshirts": "T-shirts",
  "cat.jackets": "Vestes",
  "cat.pants": "Pantalons/Shorts",
  "cat.headwear": "Couvre-chefs",
  "cat.sets": "Ensembles",
  "cat.underwear": "Sous-vêtements/Slips",
  "cat.jersey": "Maillots",
  "cat.accessories": "Accessoires",
  "cat.bags": "Sacs",
  "cat.belts": "Ceintures",
  "cat.perfumes": "Parfums",
  "cat.other": "Autres articles",
};